import { render, staticRenderFns } from "./Gmdjgw.vue?vue&type=template&id=3814bf04&"
import script from "./Gmdjgw.vue?vue&type=script&lang=js&"
export * from "./Gmdjgw.vue?vue&type=script&lang=js&"
import style0 from "./Gmdjgw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports